import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { country_list } from '../../utilities/countries';
import { Store } from '@ngrx/store';
import * as fromUI from '../../../store/actions/ui.action';
import { Observable } from 'rxjs/Observable';

// import { getLoading, getErrorMessage } from '../../../store/reducers/ui.reducer';
import { State } from '../../../store/reducers';

@Component({
  templateUrl: './full-register.component.html',
  styleUrls: ['./full-register.component.css']
})
export class FullRegisterComponent implements OnInit {
  countries: string[];
  loading$: Observable<boolean>;
  errorMessage$: Observable<any>;
  registerForm: FormGroup;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private store: Store<State>,
    public authService: AuthService
  ) {}

  ngOnInit() {
    this.countries = country_list;
    this.registerForm = this.fb.group({
      email: ['', [Validators.email, Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  register() {
    this.store.dispatch(new fromUI.PageLoading());
    this.loading$ = this.store.select(state => state.ui.loading);
    const formValues = this.registerForm.value;
    this.authService.signup(formValues.email, formValues.password);
    this.errorMessage$ = this.store.select(state => state.ui.error);
  }

  logout() {
    this.authService.logout();
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/core/components/full-register/full-register.component.ts